import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { getInstallationName } from 'shared/helpers/branding';

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) ||
    (getInstallationName() === '4pillars' ? '4pillars' : 'auto');
  const isFourpillars = selectedColorScheme === '4pillars';
  const isDark =
    isFourpillars ||
    selectedColorScheme === 'dark' ||
    (selectedColorScheme === 'auto' && isOSOnDarkMode);

  document.body.classList.toggle('dark', isDark);
  document.body.classList.toggle('theme-4pillars', isFourpillars);
  document.documentElement.classList.toggle('theme-4pillars', isFourpillars);
  document.documentElement.style.setProperty(
    'color-scheme',
    isDark ? 'dark' : 'light'
  );
};
